import jsPDF from "jspdf";
import { NumerosALetras } from 'numero-a-letras';
import { getEmpresaByCodigo } from '../Componentes/empresasConfig';

export const generarLiquidacionPDF = (datos) => {
    const doc = new jsPDF();

    const grisClaro = "#cccccc";
    const startX = 15;
    const middleX = 105;
    let y = 15;
    const periodoFormateado = `${datos.periodo.slice(0, 2)}-${datos.periodo.slice(2)}`;
    const anchoCol1 = 88;
    const anchoCol2 = 90;
    const alignRight = (value, width = 40) =>
        value.toString().padStart(width, " ");

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    let logoPDF = "";
    // ENCABEZADO EMPRESA
    // Mapeo entre código y los datos de la empresa
    // Normalizar ruta del logo recibida desde el front
    const logo = datos.logo?.toLowerCase() || "";

    // Detectar empresa según el nombre del archivo
    let empresaClave = "";
    console.log("Logo recibido para PDF:", datos.logo ? datos.logo : "No se proporcionó logo");
    if (logo.includes("idafa")) empresaClave = "INVE";    // más específica
    else if (logo.includes("dafa")) empresaClave = "DAFA";
    else if (logo.includes("fugar")) empresaClave = "FUGA";
    else if (logo.includes("extasis")) empresaClave = "TRAN";
    else if (logo.includes("nidiam")) empresaClave = "NIDI";

    const cfg = empresaClave ? getEmpresaByCodigo(empresaClave) : null;
    const empresa = cfg ? { logo: cfg.logoPDF, nombre: cfg.nombre, rut: cfg.rutFormatted } : null;

    // -------------------------------
    // IMPRESIÓN EN PDF
    // -------------------------------
    if (empresa) {

        // Nombre + RUT
        doc.text(`${empresa.rut} ${empresa.nombre}`, startX + 100, y);
        y += 5;

        // Dirección fija
        doc.text("AVENIDA LOS CARRERA, PONIENTE 301, PISO 2", startX + 100, y);
        y += 10;

        // Agregar logo
        try {
            doc.addImage(empresa.logo, "PNG", startX, 10, 40, 15);
        } catch (err) {
            console.warn("Error al cargar logo PDF:", err);
        }
    }

    y += 5;

    // TÍTULO
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("LIQUIDACION DE REMUNERACIONES", 70, y);
    y += 10;

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    // ANTECEDENTES
    // RUT, Nombre, Cargo
    doc.setFont("helvetica", "normal");
    doc.text(`RUT: ${datos.rut}`, startX, y);
    y += 6;
    doc.text(`Nombre: ${datos.nombre}`, startX, y);
    y += 6;
    doc.text(`Cargo: ${datos.cargo}`, startX, y);
    y += 6;

    // Antecedentes título en bold
    doc.setFont("helvetica", "bold");
    doc.text("Antecedentes", startX, y);
    doc.setFont("helvetica", "normal");
    y += 6;

    const colWidth = 60;  // ancho de cada columna
    const info = [
        [
            { label: "Sueldo Base:", valor: datos.sueldoBase },
            { label: "Periodo:", valor: periodoFormateado },
            { label: "Salud:", valor: datos.salud }
        ],
        [
            { label: "Sueldo Imponible:", valor: datos.sueldoImponible },
            { label: "Contratado:", valor: datos.fechaIngreso },
            { label: "UF:", valor: datos.valorUF }
        ],
        [
            { label: "Base Tributable:", valor: datos.BaseTributable },
            { label: "Tipo Contrato:", valor: datos.tipoContrato },
            { label: "AFP:", valor: datos.afpNombre }
        ]
    ];
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);

    info.forEach(fila => {
        fila.forEach((col, index) => {
            const x = startX - 2 + (index * colWidth);
            doc.text(col.label, x + 2, y);

            // Diagnóstico:
            if (col.valor === undefined || col.valor === null) {
                console.warn("Valor undefined o null en:", col.label, col.valor);
            }

            doc.text((col.valor ?? '').toString(), x + colWidth - 2, y, { align: "right" });
        });
        y += 6;
    });

    y += 4; // espacio extra después del bloque

    // LÍNEA SEPARADORA
    doc.setDrawColor(grisClaro);
    doc.line(startX, y, 195, y);
    y += 6;

    // ENCABEZADO IMPONIBLES Y DESCUENTOS
    doc.setFont("helvetica", "bold");
    doc.setFillColor(220);
    doc.rect(startX, y, anchoCol1, 8, 'F');
    doc.rect(middleX, y, anchoCol2, 8, 'F');
    doc.setTextColor(0);
    doc.text("Imponibles", startX + 2, y + 6);
    doc.text("Descuentos", middleX + 2, y + 6);
    y += 15;

    doc.setFont("helvetica", "normal");

    // Imponibles y Descuentos (estáticos)
    const imponibles = [
        { label: "Sueldo Mensual", valor: datos.baseMensual },
        { label: "Gratificación", valor: datos.gratificacion.toString() },
    ];

    if (datos.totalBonoUnico && datos.totalBonoUnico !== "0") {
        imponibles.push({
            label: datos.DescripcionBono,
            valor: datos.totalBonoUnico.toString(),
        });
    }

    if (datos.horasExtra && datos.horasExtra !== "0") {
        imponibles.push({
            label: `Horas Extras 50% (${datos.jornadaSemanal || 42} horas) - H(${datos.horasExtra})`,
            valor: datos.totalHorasExtra.toString(),
        });
    }



    if (datos.bonoCumplimiento && datos.bonoCumplimiento > 0) {
        imponibles.push({
            label: "Bono Cumplimiento",
            valor: datos.bonoCumplimiento.toString(),
        });
    }

    const descuentos = [
        { label: "AFP " + datos.afpNombre.split(" ")[0], valor: String(datos.descuentoAFP) },
        { label: "Salud 7%", valor: String(datos.descuentoFonasa) }
    ];

    if (Number(datos.seguroCesantia) > 0) {
        descuentos.push({
            label: "Seguro Cesantía",
            valor: String(datos.seguroCesantia)
        });
    }

    if (Number(String(datos.impuestoUnico).replace(/\./g, '')) > 0) {
        descuentos.push({
            label: "Impuesto Único",
            valor: String(datos.impuestoUnico)
        });
    }

    const maxRows = Math.max(imponibles.length, descuentos.length);

    for (let i = 0; i < maxRows; i++) {
        if (imponibles[i]) {
            doc.text(imponibles[i].label, startX + 2, y);
            doc.text(imponibles[i].valor, startX + anchoCol1 - 1, y, { align: "right" });
        }
        if (descuentos[i]) {
            doc.text(descuentos[i].label, middleX + 2, y);
            doc.text(descuentos[i].valor, middleX + anchoCol2 - 1, y, { align: "right" });
        }
        y += 7;
    }

    // Totales
    doc.setFont("helvetica", "bold");
    doc.text("Total Imponibles:", startX + 42, y);
    doc.text(datos.sueldoImponible, startX + anchoCol1 - 1, y, { align: "right" });
    doc.text("Total Descuentos:", middleX + 42, y);
    doc.text(datos.totalDescuentos, middleX + anchoCol2 - 1, y, { align: "right" });
    y += 3;

    doc.setFont("helvetica", "bold");
    doc.setFillColor(220);
    doc.rect(startX, y, anchoCol1, 8, 'F');
    doc.rect(middleX, y, anchoCol2, 8, 'F');
    doc.setTextColor(0);
    doc.text("No Imponibles", startX + 2, y + 6);
    doc.text("Otros Descuentos", middleX + 2, y + 6);
    y += 15;

    // No Imponibles y Otros Descuentos
    doc.setFont("helvetica", "normal");

    const noImponibles = [];

    if (datos.bonoMovilizacion && datos.bonoMovilizacion !== "") {
        noImponibles.push({ label: "Asignación Movilización", valor: datos.bonoMovilizacion.toString() });
    }

    const otrosDescuentos2 = [];
    if (datos.anticipo && datos.anticipo !== "") {
        otrosDescuentos2.push({ label: "Anticipo", valor: datos.anticipo.toString() });
    }

    if (datos.otrosDescuentos && datos.otrosDescuentos !== "") {
        otrosDescuentos2.push({ label: String(datos.otrosDescuentos), valor: datos.valorDescuento.toString() });
    }

    // Las horas no trabajadas NO van como "otro descuento": ya vienen rebajadas
    // del sueldo base. El detalle queda en "Hr(s) Atraso(s)" del movimiento.

    // Usa los arrays armados
    const noImp = noImponibles;
    const otrosDesc = otrosDescuentos2;

    const rows = Math.max(noImp.length, otrosDesc.length);

    for (let i = 0; i < rows; i++) {
        if (noImp[i]) {
            doc.text(noImp[i].label, startX + 2, y);
            doc.text(noImp[i].valor, startX + anchoCol1 - 1, y, { align: "right" });
        }
        if (otrosDesc[i]) {
            doc.text(otrosDesc[i].label, middleX + 2, y);
            doc.text(otrosDesc[i].valor, middleX + anchoCol2 - 1, y, { align: "right" });
        }
        y += 6;
    }

    doc.setFont("helvetica", "bold");
    doc.text("Total No Imponibles:", startX + 36, y);
    doc.text(datos.bonoMovilizacion, startX + anchoCol1 - 1, y, { align: "right" });
    doc.text("Total Otros Descuentos:", middleX + 31, y);
    doc.text(datos.totalOtrosDctos, middleX + anchoCol2 - 1, y, { align: "right" });
    y += 3;

    doc.setFont("helvetica", "bold");
    doc.setFillColor(220);
    doc.rect(startX, y, anchoCol1, 8, 'F');
    doc.rect(middleX, y, anchoCol2, 8, 'F');
    doc.setTextColor(0);
    doc.text("Suma Haberes:", startX + 45, y + 6);
    doc.text("Suma Descuentos:", middleX + 40, y + 6);
    doc.setFont("helvetica", "bold");
    y += 6;
    doc.text(datos.totalHaberes, startX + anchoCol1 - 1, y, { align: "right" });
    doc.text(datos.sumaDescuento.toString(), middleX + anchoCol2 - 1, y, { align: "right" });
    y += 3;

    const texto = `Total Líquido a Pagar: ${datos.montoFinal}`;
    const anchoTotal = anchoCol1 + anchoCol2 + 2;

    // Obtener el ancho del texto en el PDF actual
    const textWidth = doc.getTextWidth(texto);

    // Calcular X para centrar el texto dentro del rectángulo
    const centeredX = startX + (anchoTotal - textWidth) / 2;

    // Aplicar el mismo formato con texto centrado
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setFillColor(220);
    doc.rect(startX, y, anchoTotal, 8, 'F');
    doc.setTextColor(0);
    doc.text(texto, centeredX, y + 6); // verticalmente centrado dentro de los 8 de alto
    y += 15;

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    let liquidoEnLetras = NumerosALetras(datos.montoFinal.replace(".", ""));

    // Eliminar la parte decimal y moneda (desde espacio + dígito + '/' en adelante)
    liquidoEnLetras = liquidoEnLetras.replace(/\s\d+\/\d+\sM\.N\.?$/, '');

    doc.text(`SON: ${liquidoEnLetras}.`, startX, y);
    y += 10;

    // MOVIMIENTO DE ASISTENCIA
    doc.setFont("helvetica", "bold");
    doc.text("Movimiento de Asistencia", startX, y);
    doc.text("Movimientos", middleX, y);
    y += 6;

    // ---------- OBSERVACIONES (derecha) ----------
    doc.setFont("helvetica", "normal"); // <- aquí ponemos normal
    const lineas = datos.observaciones.split("|");
    let yy = y; // altura inicial compartida
    const x = middleX;

    lineas.forEach(linea => {
        doc.text(linea.trim(), x, yy);
        yy += 10; // salto entre observaciones
    });

    // ---------- ASISTENCIA (izquierda) ----------
    let yLeft = y; // usamos la misma base inicial que yy

    doc.text(`Asistencia: ${datos.diasTrabajados}`, startX, yLeft);
    yLeft += 6;
    doc.text(`Ausentismos: ${datos.diasAusentes}`, startX, yLeft);
    yLeft += 6;
    doc.text(`Licencias Médicas: ${datos.diasLicencia}`, startX, yLeft);
    yLeft += 6;
    doc.text(`Vacaciones: ${datos.diasVacaciones}`, startX, yLeft);
    yLeft += 6;
    doc.text(
        `Hr(s) Atraso(s): ${formatearHoraEntera(datos.horasDescontar)}`,
        startX,
        yLeft
    );

    // ---------- Actualizamos Y para continuar después ----------
    y = Math.max(yy, yLeft) + 15;

    // FIRMA
    doc.setFont("helvetica", "normal");
    doc.text("__________________________", startX, y);
    doc.text("Firma Trabajador", startX, y + 5);
    y += 15;

    // DECLARACIÓN FINAL
    doc.text(
        "Recibí a mi entera satisfacción detalle liquidación de sueldo y líquido a pagar, dejando constancia que no tengo reclamo alguno a formular.",
        startX,
        y,
        { maxWidth: 180 }
    );

    doc.save(`Liquidacion_${datos.nombre}_${datos.periodo}.pdf`);
};
function formatearHoraEntera(horas) {
    return `${horas.toString().padStart(2, '0')}:00`;
}